import { Component } from "react";
import { createPortal } from "react-dom";

/**
 * Renders children directly under <body>, outside #bl-idg-root.
 *
 * The tool root creates its own stacking context (position: relative; z-index: 10),
 * so any position: fixed element inside it can be painted over by later page
 * sections such as the theme's newsletter block. Rendering fixed UI (the limit
 * bar and the limit popup) through this portal lets their z-index apply to the
 * whole page.
 */
export default class Portal extends Component {
	constructor(props) {
		super(props);
		this.el = document.createElement("div");
		this.el.className = "idg-portal";
	}

	componentDidMount() {
		document.body.appendChild(this.el);
	}

	componentWillUnmount() {
		if (this.el.parentNode) {
			this.el.parentNode.removeChild(this.el);
		}
	}

	render() {
		return createPortal(this.props.children, this.el);
	}
}
